module.exports = __webpack_public_path__ + "static/media/greenday2.fea159a1.mov";